import React, { } from "react";
import { colors } from "../../Styles"

interface Overlay_Props {
  color?: colors
  zIndex?: number
}

export default function Overlay({color = colors.transparent, zIndex = 999 }:Overlay_Props) {
  
  return (
    <div style={{ 
      backgroundColor: color, 
      zIndex: zIndex,
      position: "absolute", 
      top: 0, 
      left: 0, 
      bottom: 0, 
      right: 0
    }}/>
  )
}

